import cloneDeep from 'lodash/cloneDeep';

import v120Schema from 'src/components/forms/schemas/eventResult/inquiryPotentialPatient/1.2.0';

const v130Schema = cloneDeep(v120Schema);
v130Schema.properties.callType.enum.push('Outgoing (responding to Quartet referral)');

export default v130Schema;
